import "../CSS/Landing.css";
import Footer from "./Footer";
import Navbar from "./Header";
import { Link } from "react-router";
import github from "../Images/github.png";
import html from "../Images/HTML.png";
import css from "../Images/css.png";
import tailwind from "../Images/tailwind.jpg";
import bootstrap from "../Images/bootstrap.png";
import javascript from "../Images//JavaScript.png";
import react from "../Images/react.png";

function Landing() {
  return (
    <div className="landing">
      <Navbar />
      <div className="landing-container">
        <div className="landing-text">
          <h3>React Front-end developer</h3>
          <p>Hi, My name's Ahmed and i'm React front-end developer</p>
        </div>
        <div className="skills">
          <img className="html" src={html} />
          <img className="css" src={css} />
          <img className="tailwind" src={tailwind} />
          <img className="bootstrap" src={bootstrap} />
          <img className="javascript" src={javascript} />
          <img className="react" src={react} />
        </div>
        <div className="github">
          <Link className="Link" to="/cards">
            My projects
          </Link>
          <div className="github-link">
            <img
              src={github}
              onClick={() => {
                window.open("https://github.com/AhmedElabher", "_blank");
              }}
            ></img>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Landing;
